<!-- <div [formGroup]="elementForm"> -->
<div>
  <div class="flex bg-primary flex-wrap">
    <div class="flex flex-none content-center justify-start content-center">
      <div class="p-buttonset flex flex-wrap content-center justify-end">
        @if (showNewButton === true) {
          <p-button [pTooltip]="newButtonTooltip" (click)="triggerAdd()">
            <i [class]="defaultIcon.Add" style="font-size: 1.5rem" class="vertical-align-middle"></i>
            <span class="hidden md:inline pl-1 vertical-align-middle text-base">{{ newButtonLabel }}</span>
          </p-button>
        }
      </div>
      @if (menuItems$ | async; as menuItems) {
        <p-button class="content-center" (click)="tieredMenu.toggle($event)"
          ><i [class]="defaultIcon.Menu"></i
        ></p-button>
        <s-ui-tieredMenu #tieredMenu [menuItems]="menuItems" />
      }
      <ng-template [ngTemplateOutlet]="menuSuffixTemplate"></ng-template>
      <div class="hidden md:inline-flex content-center items-center">
        <ng-container *ngTemplateOutlet="filterBar"></ng-container>
      </div>
    </div>
    <div class="grow flex content-center justify-center text-overflow-clip bg-primary">
      <span class="view-title">
        <div class="flex bg-primary my-1">
          <div class="hidden md:flex flex-none align-items-left justify-content-left">
            <span class="w-10rem"></span>
          </div>
          <div class="grow flex items-center justify-center mt-1">
            @switch (dateBarType) {
              @case ('week') {
                <s-form-input-week
                  #rangePicker
                  [defaultRange]="defaultDateRange"
                  [defaultRangeType]="dateRangeType"
                  (DateRangeChange)="changeDateRange($event)"
                  [label]="dateBarLabel"
                  [labelLocation]="'on'"
                  [required]="true"
                  size="small"
                />
              }
              @case ('weekRange') {
                <s-form-input-week-range
                  #rangePicker
                  [defaultRange]="defaultDateRange"
                  [defaultRangeType]="dateRangeType"
                  (DateRangeChange)="changeDateRange($event)"
                  [labelLocation]="'on'"
                  [required]="true"
                  size="small"
                />
              }
              @case ('weekRangeWithNum') {
                <s-form-input-week-range
                  #rangePicker
                  [defaultRange]="defaultDateRange"
                  [defaultRangeType]="dateRangeType"
                  (DateRangeChange)="changeDateRange($event)"
                  [showWeekNumber]="true"
                  [labelLocation]="'on'"
                  [required]="true"
                  size="small"
                />
              }
              @case ('month') {
                <s-form-input-month
                  #rangePicker
                  [defaultRange]="defaultDateRange"
                  [defaultRangeType]="dateRangeType"
                  (DateRangeChange)="changeDateRange($event)"
                  [labelLocation]="'on'"
                  [required]="true"
                  size="small"
                />
              }
              @case ('monthRange') {
                <s-form-input-month-range
                  #rangePicker
                  [defaultRange]="defaultDateRange"
                  [defaultRangeType]="dateRangeType"
                  (DateRangeChange)="changeDateRange($event)"
                  [labelLocation]="'on'"
                  [required]="true"
                  size="small"
                />
              }
              @case ('day') {
                <s-form-input-date
                  #dayPicker
                  [schema]="false"
                  [label]="dateBarLabel ?? 'Date'"
                  [defaultDay]="defaultDay"
                  [showButtons]="true"
                  (DateChange)="changeDate($event)"
                  [showClear]="false"
                  [labelLocation]="'on'"
                  [required]="true"
                  size="small"
                />
              }
              @default {
                <!-- <span class="text-color">No Date Bar</span> -->
              }
            }
            @if (viewSuffixTemplate) {
              <div class="flex flex-col h-full justify-end">
                <ng-template [ngTemplateOutlet]="viewSuffixTemplate"></ng-template>
              </div>
            }
          </div>
          <div class="flex flex-none align-items-right justify-content-right"></div>
        </div>
      </span>
    </div>
    <div class="flex flex-none">
      <span class="flex lg:hidden p-buttonset flex-wrap content-center justify-end">
        @if (mobileMenuItems.length > 0) {
          <p-button (click)="mobileMenu.toggle($event)">
            <i [class]="defaultIcon.Menu" style="font-size: 1.5rem"></i>
          </p-button>
          <p-tieredMenu #mobileMenu [model]="mobileMenuItems" [popup]="true" appendTo="body" />
        }
      </span>
      <span class="hidden lg:flex p-buttonset flex-wrap content-center justify-end">
        @if (showPrint) {
          <p-button (click)="triggerPrint()">
            <i [class]="defaultIcon.Print" style="font-size: 1.5rem"></i>
          </p-button>
        }
        @if (showDownload) {
          <p-button (click)="downLoadMenu.toggle($event)">
            <i [class]="defaultIcon.Download" style="font-size: 1.5rem"></i>
          </p-button>
        }
        <p-tieredMenu #downLoadMenu [model]="downloadMenuItems" [popup]="true" appendTo="body" />
      </span>
    </div>
  </div>

  <div class="flex bg-primary md:hidden">
    <div class="flex justify-between">
      <ng-container *ngTemplateOutlet="filterBar"></ng-container>
    </div>
    <!--leaving empty to keep the filter bar on one row-->
    <div class="grow flex items-center justify-center"></div>
  </div>

  <ng-template #filterBar>
    <ng-content></ng-content>
    @if (showFilter) {
      <div>
        <s-form-input-text
          #filterInput
          fieldName="filterString"
          [form]="elementForm"
          [schema]="false"
          label="Filter"
          labelVariant="on"
          inputStyle="min-width: 0; width: 160px;"
          size="small"
        >
          <ng-template #suffix>
            <p-inputgroup-addon>
              <p-button (click)="filterClear()" severity="primary">
                <i [class]="defaultIcon.Clear"></i>
              </p-button>
            </p-inputgroup-addon>
            @if (showCustomFilterMenu) {
              <p-inputgroup-addon>
                <p-button (click)="extraFilters.toggle($event)" severity="primary" label="Extra Filters">
                  <i [class]="defaultIcon.Menu"></i>
                </p-button>
              </p-inputgroup-addon>
            }
          </ng-template>
        </s-form-input-text>
      </div>
      <p-popover #extraFilters>
        <ng-template pTemplate="content" let-option>
          <div class="text-primary">
            <h1 class="text-primary pl-2">Extra Filters</h1>
            @if (customFilters$ | async; as customFilters) {
              @for (element of customFilters; track element.id) {
                <s-form-input-checkbox
                  [fieldName]="element.id"
                  [form]="elementForm"
                  [schema]="false"
                  [label]="element.description"
                />
              }
            }
          </div>
        </ng-template>
      </p-popover>
    }
    <ng-template [ngTemplateOutlet]="filterTemplate"></ng-template>
  </ng-template>
</div>
